import React, {useEffect} from 'react';
import {Navigate, Route} from 'react-router-dom';
import urlMap from './redirectUrlMap.json';

function ExternalRedirect({to}) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

const rel = p => (p.startsWith('/') ? p.slice(1) : p);

// Router matching ignores trailing slashes, so a `from = to + '/'` route would
// also match the canonical URL and self-redirect forever (blanking the page).
// Those entries are covered by <TrailingSlashRedirect/> mounted in App instead.
export default urlMap
  .filter(({from, to}) => from !== `${to}/`)
  .map(({from, to}) =>
    to.startsWith('http') ? (
      <Route
        key={from}
        path={rel(from)}
        element={<ExternalRedirect to={to} />}
      />
    ) : (
      <Route key={from} path={rel(from)} element={<Navigate to={to} replace />} />
    )
  );
